import { fr_FR } from '@/assets';
import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';


i18n
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        resources: {
            fr: {translation: fr_FR}
        },
        fallbackLng: 'fr',
        debug: import.meta.env.DEV,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        react: {
            useSuspense: false
        }
    });


export default i18n;